module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABA0lEQVR4nO3YvUrEQBSG4YPelaXo4k8z73eM2Gip4k3kTrXRZsFCZFVwdWVkbULEQln3DOeBadK9JDmZiVlKKaWUUkqrAhwBU+BB0qlFBJwAc0mLumpM13WbFgnQSXr9iliG3Pd9v2FRSPKRiLm7H1sUkg4kvQwi3oAzi6KUsj+MkPQu6dyiAPaA52EEcGFRuPtkLKKUcmlRALvf3Ikri0LSDvAUOgLYljQbRKxy3dTh8qsId98CHv8xYrEc67cZsi6PFnBdR779hSZe9qbGb1MfxKa2KE1tGpvaxv90sKrnd4uGkaOupDtr4eeDooZUpRTVgLovAg4/L6aUUkoppWRr5AN4iOx6IaXVUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/leftArrowIcon.png
// module id = 813
// module chunks = 7